export default "__VITE_ASSET__4151a7ff__"